import { render } from "./add.html?vue&type=template&id=82b3338e&scoped=true&ts=true"
import script from "./add.ts?vue&type=script&lang=ts"
export * from "./add.ts?vue&type=script&lang=ts"

import "./add.css?vue&type=style&index=0&id=82b3338e&scoped=true&lang=css"

import exportComponent from "E:\\yl\\web\\lvxingshibie-backend\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82b3338e"]])

export default __exports__